import { render, staticRenderFns } from "./MobileSidebar.vue?vue&type=template&id=0c48508b&scoped=true"
import script from "./MobileSidebar.vue?vue&type=script&lang=js"
export * from "./MobileSidebar.vue?vue&type=script&lang=js"
import style0 from "./MobileSidebar.vue?vue&type=style&index=0&id=0c48508b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c48508b",
  null
  
)

export default component.exports